module.exports = __webpack_public_path__ + "img/manda_015.e089022f.png";